import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { JobCard } from "../components/JobCard";
import { Button } from "../components/ui/button";
import { Hero } from "../components/home/Hero";
import { Stats } from "../components/home/Stats";
import { Sectors } from "../components/home/Sectors";
import { HowItWorks } from "../components/home/HowItWorks";
import { Benefits } from "../components/home/Benefits";
import { Cities } from "../components/home/Cities";
import { AiSection } from "../components/home/AiSection";
import { Testimonials } from "../components/home/Testimonials";
import { Pricing } from "../components/home/Pricing";
import { Vision } from "../components/home/Vision";
import { Faq } from "../components/home/Faq";
import { CtaFinal } from "../components/home/CtaFinal";
import { PortugalMap } from "../components/PortugalMap";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    api.get("/jobs", { params: { featured: true, limit: 6 } }).then((r) => setFeatured(r.data.jobs)).catch(() => {});
    api.get("/stats/public").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <Hero stats={stats} />
      <Stats stats={stats} />

      {/* Vagas em destaque */}
      {featured.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-8 pt-16">
          <div className="flex items-end justify-between mb-8">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-amber-600 mb-2">A não perder</p>
              <h2 className="font-heading font-black tracking-tighter text-2xl sm:text-3xl text-slate-900">Vagas em destaque</h2>
            </div>
            <Button data-testid="see-all-jobs-btn" variant="link" className="text-slate-600 hover:text-amber-600" onClick={() => navigate("/empregos")}>
              Ver todas →
            </Button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {featured.map((j) => <JobCard key={j.id} job={j} />)}
          </div>
        </section>
      )}

      {/* Setores com imagens reais */}
      <Sectors stats={stats} />

      <HowItWorks />
      <Benefits />

      {/* Cidades em destaque */}
      <Cities />

      {/* Mapa Interativo — vagas por distrito */}
      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <PortugalMap />
      </section>

      <AiSection />
      <Testimonials />
      <Pricing />
      <Vision />
      <Faq />
      <CtaFinal />
      <Footer />
    </div>
  );
}
